import { MdOutlineArrowRight, MdOutlineArrowLeft } from "react-icons/md";
import { FaCheckSquare } from "react-icons/fa";
import { IoDiamondSharp } from "react-icons/io5";
import { HiMiniPercentBadge } from "react-icons/hi2";
import { FaTiktok } from "react-icons/fa";
import { PiInstagramLogoFill } from "react-icons/pi";
import { FaYoutube } from "react-icons/fa6";
import { HiXCircle } from "react-icons/hi";
export const Icons = {
  RightArrow: MdOutlineArrowRight,
  LeftArrow: MdOutlineArrowLeft,
  check: FaCheckSquare,
  Diamond: IoDiamondSharp,
  percent: HiMiniPercentBadge,
  tiktok: FaTiktok,
  instagram: PiInstagramLogoFill,
  youtube: FaYoutube,
  X: HiXCircle,
};
